module.exports = __webpack_public_path__ + "img/toolsItem02.4d088f37.png";